const FULL_DOC_TEMPLATE_KEY = 'full-doc'

// A live run polls its generation task for at most an hour. `created` is a
// timezone-less UTC timestamp that the browser parses as local time, so it can
// look up to a couple of hours older than it is -- keep a wide margin so a
// run still in progress (e.g. by a colleague) is never treated as stale.
export const STALE_FULL_DOCUMENT_AGE_MS = 6 * 60 * 60 * 1000

/**
 * Full documents still linked to the "full-doc" template: leftovers of runs
 * that were interrupted before the document was unlinked.
 */
export const findStaleFullDocuments = (files: FileItem[], now = Date.now()): FileItem[] =>
  files.filter(
    file =>
      file.template_key === FULL_DOC_TEMPLATE_KEY &&
      !!file.created &&
      now - new Date(file.created).getTime() > STALE_FULL_DOCUMENT_AGE_MS,
  )

// Template instance guid of a project file ("Dateien", element files below
// their element), see the backend's PROJECT_FILE_TEMPLATE_INSTANCE_PREFIX
const projectFileTemplateGuid = (fileGuid: string) => `project-file.${fileGuid}`

/**
 * Template instance guids already in the document structure ("Template
 * hinzufügen" marks them as added): the item's own template and, for a page
 * showing a project file, that file.
 */
export const getAddedTemplateGuids = (items: (SectionItem | FileItem)[]): string[] =>
  items.flatMap(item => {
    if (!item.template_key) return []
    if (item.type === 'section') return [item.template_key]

    const ownGuid = item.element_guid
      ? `${item.template_key}.${item.element_guid}`
      : item.template_key
    return item.attachment ? [ownGuid, projectFileTemplateGuid(item.attachment.guid)] : [ownGuid]
  })
